import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { parseHint } from '../utils/manager/hint-manager';

function Hint({ value, className, showParenthesis = false }) {
  const classes = useStyles();

  return (
    value && (
      <span className={classNames(classes.container, className)}>
        {parseHint(value, showParenthesis)}
      </span>
    )
  );
}

const useStyles = createUseStyles({
  container: {
    whiteSpace: 'nowrap',
    textTransform: 'lowercase',
  },
});

export { Hint };
